import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';
import Icon from 'components/UI/Icon';

import useIntersection from 'hooks/useIntersection';

import * as styles from './list.module.scss';

const List = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection();

  return (
    <div ref={scrollWrapper}>
      <ul className={classnames(styles.list)} ref={inViewRefSec}>
        {data.map((item, i) => (
          <li
            key={i}
            className={classnames({ [styles.jsAnimInit]: inViewSec })}
          >
            <Link
              to={item.featuresListLink.uri}
              className={classnames(styles.item)}
            >
              <p className={classnames(styles.iconsWrap)}>
                <img src={item.featuresListIcon?.sourceUrl} alt="" />
                <Icon name={'corner-arrow-small'} />
              </p>

              <h3 className={classnames(styles.item_title, 'cr-h3')}>
                {item.featuresListTitle}
              </h3>

              <p>{item.featuresListDescription}</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;
